import React from 'react';

const BlogCard = ({ id, photo, title, category }) => {

	return (
		<div 
			className='card-style'
			style={{ display: 'flex', flexDirection: 'column'  }}
		>
			<div style={{ alignSelf: 'center' }}>
				<img className='splashimage' src={photo} alt={title}/>
			</div>
			<div>
				<p className='category'>{category}</p>
				<h2 className='title pointer-cursor'>
              		{title}
            	</h2>
			</div>
		</div>

	)
}

export default BlogCard;